import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/artstation': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M2 377.4h315.1l59.2 102.6h-285.4 0c-17.5 0-38-12.7-45.9-28.3zM501.8 350c19 29.4-0.1 55.9-2 59.1l-40.7 70.5-257.3-447.6h88.4 0c17.1 0 37.4 12.2 45.4 27.3zM275 304.5h-231l115.5-200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/artstation.js
// module id = 715
// module chunks = 0